import { useTemplatesContext } from "@/pages/templates/context/templatesContext";
import { createStyles, makeStyles } from "@mui/styles";
import Grid2 from "@mui/material/Grid2";
import type { EditableCallbackParams } from "ag-grid-enterprise";

type Props = EditableCallbackParams;

const useStyles = makeStyles((theme) =>
	createStyles({
		input: {
			"&:focus::placeholder": {
				color: "transparent !important",
			},
		},
	}),
);

export const LOTONameColumn = ({ data }: Props) => {
	const classes = useStyles();
	const {
		state: { LOTONameToLink },
		actions: { setLOTONameToLink },
	} = useTemplatesContext();

	const handleChangeLOTONameChange = (e: any) => {
		setLOTONameToLink(e.target.value.toUpperCase());
	};

	if (data.id === -1) {
		return (
			<Grid2
				container
				style={{
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<input
					style={{
						outline: "none",
						border: "none",
						lineBreak: "auto",
						textAlign: "center",
						width: 152,
						maxWidth: 152,
						marginRight: "10px",
					}}
					value={LOTONameToLink}
					onChange={handleChangeLOTONameChange}
					placeholder={"Enter a name for LOTO"}
					className={classes.input}
					autoComplete="false"
				/>
			</Grid2>
		);
	} else return data?.LOTOName;
};
